var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 10.2316C3.33398 8.73587 4.54654 7.52332 6.04232 7.52332C7.53809 7.52332 8.75065 8.73587 8.75065 10.2316C8.75065 11.7274 7.53809 12.94 6.04232 12.94C4.54654 12.94 3.33398 11.7274 3.33398 10.2316ZM0.833984 18.565C0.833984 15.8639 3.22322 13.7733 6.04232 13.7733C8.8614 13.7733 11.2507 15.8639 11.2507 18.565C11.2507 18.9101 10.9708 19.19 10.6257 19.19H1.45898C1.11381 19.19 0.833984 18.9101 0.833984 18.565Z",
    fill: "#FF9355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9577 1.27332C11.3379 1.27332 9.16602 3.31214 9.16602 5.88444C9.16602 7.11652 9.66885 8.23252 10.4787 9.05507C10.492 9.06865 10.5219 9.11282 10.5219 9.11282C10.4703 9.36565 10.3598 9.59907 10.2023 9.7929C10.0632 9.96398 10.0246 10.1957 10.1007 10.4027C10.1768 10.6096 10.3563 10.7612 10.5731 10.8016C11.3153 10.9396 12.0833 10.8149 12.741 10.4651C12.8103 10.4283 12.8584 10.4027 12.8947 10.3842C12.9281 10.3901 12.9876 10.4011 13.0362 10.4102C13.3399 10.4672 13.6482 10.4959 13.9577 10.4956C16.5773 10.4956 18.7493 8.45673 18.7493 5.88444C18.7493 3.31213 16.5773 1.27332 13.9577 1.27332ZM14.5897 4.39832C14.5897 4.05314 14.3098 3.77332 13.9647 3.77332C13.6195 3.77332 13.3397 4.05314 13.3397 4.39832V6.06497C13.3397 6.41015 13.6195 6.68997 13.9647 6.68997C14.3098 6.68997 14.5897 6.41015 14.5897 6.06497V4.39832ZM13.9577 7.10663C13.6125 7.10663 13.3327 7.38646 13.3327 7.73163C13.3327 8.07682 13.6125 8.35663 13.9577 8.35663H13.9644C14.3096 8.35663 14.5894 8.07682 14.5894 7.73163C14.5894 7.38646 14.3096 7.10663 13.9644 7.10663H13.9577Z",
    fill: "#FF9355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.83e001de41e6298052d8959ec7c14975.svg";
export { ForwardRef as ReactComponent };